import { Fragment } from 'react';
import { Mic, Volume2 } from 'lucide-react';

export default function VoiceSerial({ transcript, status, taskState }) {
  const history = taskState?.history || [];
  
  return (
    <div className="flex flex-col items-center gap-8 z-10">
      <h2 className="text-2xl md:text-3xl font-semibold text-muted-foreground text-center z-10 max-w-3xl min-h-[60px] flex items-center">
        Вычтите 7 из 100 и продолжайте вычитать
      </h2>
      
      <div className="flex items-center gap-4 flex-wrap justify-center max-w-3xl">
        <span className="text-5xl font-bold text-primary">100</span>
        {history.map((num, i) => {
          const expected = i === 0 ? 93 : (history[i-1] - 7);
          const isCorrect = num === expected;
          return (
            <Fragment key={i}>
              <span className="text-3xl text-muted-foreground">→</span>
              <span className={`text-5xl font-bold ${isCorrect ? 'text-green-500' : 'text-red-500'}`}>{num}</span>
            </Fragment>
          );
        })}
      </div>
      
      <div className="flex flex-col items-center gap-4">
        {status === 'speaking' && <Volume2 className="size-12 text-accent animate-pulse" />}
        {status === 'listening' && (
          <div className="flex flex-col items-center gap-4">
            <Mic className="size-12 text-red-500 animate-bounce" />
            <div className="px-8 py-6 bg-secondary rounded-full border-2 border-red-500/30 text-center min-h-[80px] flex items-center max-w-md">
              <span className="text-2xl text-primary font-medium">{transcript || "Слушаю ответ..."}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}